import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Format an ingredient/quantity amount for display: round to at most 2 decimal
 * places and drop trailing zeros. e.g. 0.66666 -> "0.67", 2 -> "2", 1.5 -> "1.5".
 */
export function formatAmount(value: number): string {
    if (!Number.isFinite(value)) return '0';
    return parseFloat(value.toFixed(2)).toString();
}
